import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ResponsiveImage from 'components/util/ResponsiveImage'
import styles from './_makeMovesTogether.css'
import leaderboard from 'images/app-page/make-moves-together/cha-leaderboard.png'
import feed from 'images/app-page/make-moves-together/cha-feed.png'
import medals from 'images/app-page/make-moves-together/cha-medals.png'
import runners from 'images/app-page/make-moves-together/cha-runners.png'
import biker from 'images/app-page/make-moves-together/cha-biker.png'

function MakeMovesTogther (props) {
  const { slug } = props.site

  const midground = slug === 'ride' ? biker : runners
  const showMedals = slug !== 'ride'
  const flavorClass = styles[slug] || ''

  return (
    <div className={styles.makeMovesTogetherWrapper}>
      <div className={`${styles.makeMovesTogether} ${flavorClass}`}>
        <div className={styles.content}>
          <Title color="white">
            <FormattedMessage id='appPage.makeMovesTogether.title' defaultMessage={`Make Moves,\n Together`} />
          </Title>
          <Caption color="white">
            <FormattedMessage
              id='appPage.makeMovesTogether.caption'
              defaultMessage='Start challenges with friends and push your crew to set new goals.'
            />
          </Caption>
        </div>
        <div className={styles.screens}>
          <div className={styles.feed}>
            <img src={feed} />
          </div>
          <div className={styles.leaderboard}>
            <img src={leaderboard} />
          </div>
        </div>
        <div className={styles.midground}>
          <ResponsiveImage large={midground} />
        </div>
        { showMedals ?
          <div className={styles.medals}>
            <ResponsiveImage large={medals} />
          </div>
        : null }
      </div>
    </div>
  )

}

MakeMovesTogther.propTypes = {
  site: PropTypes.object,
}

export default MakeMovesTogther



// WEBPACK FOOTER //
// ./src/components/app-page/make-moves-together/index.jsx